import { render, staticRenderFns } from "./TucowsPromosExpiringInAMonth.vue?vue&type=template&id=21fdbadc"
import script from "./TucowsPromosExpiringInAMonth.vue?vue&type=script&lang=js"
export * from "./TucowsPromosExpiringInAMonth.vue?vue&type=script&lang=js"
import style0 from "./TucowsPromosExpiringInAMonth.vue?vue&type=style&index=0&id=21fdbadc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports